//引入样式
require('./sass/prompt.scss');


/*
* option 用户传入的配置参数
* option.position 决定登录框以何种方式显示在页面中
* */
module.exports = function (option) {
    //获取登录框模板
    var str = require('./templates/prompt.ejs')();
    
    
    //先判断用户是否传入的参数
    if (!option){
        //如果没有传入配置参数，则默认以遮罩层方式显示
        layer.open({
            type: 1,
            title: false,
            // move: '.layui-layer-content',
            content : str
        })
    }
};


// WEBPACK FOOTER //
// ./src/common/customizePrompt/customizePrompt.js